import { Component, Inject, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { Router } from '@angular/router';
import { PoliciesHttpService } from 'src/app/services/httpServices/governance/policiesHttpService/policies-http.service';

export interface IntegrationCreatedInput {
  integrationId: string;
}

@Component({
  selector: 'app-integration-created',
  templateUrl: './integration-created.component.html',
  styleUrls: ['./integration-created.component.scss'],
})
export class IntegrationCreatedComponent implements OnInit {
  private _policyConfigUrl: string;
  private readonly _integrationId: string;

  constructor(
    public dialogRef: MatDialogRef<IntegrationCreatedComponent>,
    @Inject(MAT_DIALOG_DATA) public input: IntegrationCreatedInput,
    private readonly _policiesHttpService: PoliciesHttpService,
    private readonly _router: Router
  ) {
    this._integrationId = input.integrationId;
  }

  ngOnInit(): void {
    this._policiesHttpService.getIntegrationPolicies(this._integrationId).subscribe((policies) => {
      this._policyConfigUrl = `app/policies/${policies[0].id}?integration=${this._integrationId}&tab=configuration`;
    });
  }

  public onConfirm() {
    this._router.navigateByUrl(this._policyConfigUrl);
  }

  public close() {
    this.dialogRef.close();
  }
}
